<template>
    <portal>
        <div class="dgov2-popup">
            <div class="dgov2-popup-screen">
            </div>
            <div class="dgov2-popup-container"
                 v-bind:style="containerStyles">
                <div class="dgov2-popup-close" v-on:click="handleClose"><i class="fas fa-times" /></div>
                <div class="dgov2-popup-contents"
                     data-media-id="pop">
                    <div class="dgov2-popup-media" v-bind:style="mediaStyles">
                        <slick-slide-show ref="slickSlideshow"
                                          v-if="slideshowOn"
                                          :uniqueId="options.moduleId"
                                          :initialSlide="options.initialSlide"
                                          :onSlideChange="onSlideChange"
                                          :mediaHeight="mediaHeight">
                            <cropzoomImg v-for="slide in options.slides"
                                         :key="slide.title"
                                         ref="imgs"
                                         :alt="slide.alt"
                                         :debug="true"
                                         :src="slide.imageUrl"
                                         :title="slide.title"
                                         :aspect-ratio="mediaAspectRatio"
                                         :slide="slide"
                                         :portalId="options.portalId" />
                        </slick-slide-show>
                    </div>
                    <div class="dgov2-popup-info"
                         v-on:keyup.escape="onEscape"
                         v-bind:style="infoStyles" v-cloak>
                        <div class="dgov2-popup-info-caption">
                            <strong class="slide-count">
                                {{slideNumber}}/{{numSlides}}
                            </strong>
                            <span class="slide-info-separator">
                                -
                            </span>
                            <span class="slide-info-title" v-if="slideTitle">
                                <span class="slide-title">
                                    {{slideTitle}}
                                </span>
                                -
                            </span>
                            <span class="slide-caption">
                                {{slideCaption}}
                            </span>
                        </div>

                        <div class="dgov2-popup-info-bottom">
                            <div class="bottom-content">
                                <div class="social">
                                    <span class="subhead">Share:</span>
                                    <div class="social-inner">
                                        <div class="a2a_kit a2a_default_style social-inner"
                                             :data-a2a-url="shareUrl" :data-a2a-title="slideTitle">
                                            <a class="a2a_button_facebook social-link" aria-label="Share to Facebook">
                                                <span class="fa fa-facebook"></span>
                                            </a>
                                            <a class="a2a_button_x social-link" aria-label="Share to X">
                                                <span class="fa-brands fa-x-twitter"></span>
                                            </a>
                                        </div>
                                        <div class="social-link social-link-more" tabindex="0" aria-haspopup="true" onclick="dgov2ss_handleSocialLinkMoreClick(event)">
                                            <span class="fas fa-share"></span>
                                            <div class="more-share more-share-dark">
                                                <div class="social-link-more-close">&times;</div>
                                                <div class="title">Share</div>
                                                <a class="social-link-link social-link" :data-url="shareUrl" href="javascript:void(0)" onclick="dgov2ss_handleCopyLinkClick(event)" rel="noreferrer noopener" tabindex="0">
                                                    <div class="social-link-inner">
                                                        <span class="fa fa-link"></span> <b class="copy-link-text">Copy Link</b>
                                                    </div>
                                                </a>
                                                <div class="a2a_kit a2a_default_style" :data-a2a-url="shareUrl" :data-a2a-title="slideTitle">
                                                    <a class="a2a_button_email social-link">
                                                        <div class="social-link-inner">
                                                            <span class="fa fa-envelope"></span> Email
                                                        </div>
                                                    </a>
                                                    <a class="a2a_button_facebook social-link">
                                                        <div class="social-link-inner">
                                                            <span class="fa fa-facebook"></span> Facebook
                                                        </div>
                                                    </a>
                                                    <a class="a2a_button_x social-link">
                                                        <div class="social-link-inner">
                                                            <span class="fa-brands fa-x-twitter"></span> X
                                                        </div>
                                                    </a>
                                                    <a class="a2a_button_linkedin social-link">
                                                        <div class="social-link-inner">
                                                            <span class="fa fa-linkedin"></span> LinkedIn
                                                        </div>
                                                    </a>
                                                    <a class="a2a_button_whatsapp social-link">
                                                        <div class="social-link-inner last">
                                                            <span class="fa fa-whatsapp"></span> WhatsApp
                                                        </div>
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="action">
                                    <div class="title" v-if="false">
                                        {{slideTitle}}
                                    </div>
                                    <div class="action-item download-link" v-if="!isVideo">
                                        <span>Download:</span>
                                        <a v-bind:href="hiresUrl" v-bind:title="slideTitle" target="_blank" class="action-frame article-link">
                                            Full Size ({{fileSize}})
                                        </a>
                                    </div>
                                    <div class="action-item photographer" v-if="photographer">
                                        <div class="action-item action-frame">
                                            <span>Credit:</span> {{photographer}}
                                        </div>
                                    </div>
                                    <div class="action-item virin" v-if="virin">
                                        <div class="action-item action-frame">
                                            <span class="virin-value">VIRIN:</span>{{virin}}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </portal>
</template>

<script>
import cropzoomImg from './cropzoomImg.vue';
import slickSlideShow from './slickSlideShow.vue';

const DEBUG=false;
export default {
    name: 'dgov2-popup',
    props: {
        mediaAspectRatio: {
            type: Number ,
            default: 3/2,
        },
        options: {
            type: Object,
            default: {slides:[]},
        },
        hidden: {
            type: Boolean,
            default: true,
        },
        onClose: {
            type: Function,
        },
    },
    components: {cropzoomImg,  slickSlideShow},
    data: function () {
        return {
            slideshowOn: true,
            currentSlideIndex: this.$props.options.initialSlide,

            popupMargin: 60, //px
            smallPopupMargin: 0, // needs to be zero so popup remains scrollable on mobile
            maxPopupWidth: 1200,

            contentTop: 0,
            contentBottom: 0,
            contentLeft: 0,
            contentRight: 0,
            contentPadding: 20,
            mediaHeight: 0,
            mediaWidth:0,

            infoWidth: 300,
            smallSize: false,
            scrollPosition: 0,
        }
    },
    computed: {
        containerStyles: function () {
            let styles;
            styles = {
                top: this.withPx(this.contentTop),
                bottom: this.contentBottom === 'auto' ? 'auto' : this.withPx(this.contentBottom),
                left: this.withPx(this.contentLeft),
                right: this.withPx(this.contentRight),
                padding: this.smallSize ? null : this.withPx(this.contentPadding),
            }
            if (DEBUG) console.log("d2p141: container styles", styles);
            return styles;
        },
        currentSlide: function () {
            if (this.$props.options)
            {
                const slide = this.$props.options.slides[this.currentSlideIndex];
                return slide;
            }
            else {
                return {}
            }
        },
        numSlides: function () {
            if (DEBUG) {
                console.log("slidenum: ", this.$props.options.slides);
            }
            return this.$props.options.slides.length;
        },
        slideCaption: function () {
            return this.currentSlide.description;
        },
        slideNumber: function () {
            return this.currentSlideIndex + 1;
        },
        slideTitle: function () {
            return this.currentSlide.title;
        },
        originalUrl: function () {
            return this.currentSlide.imageUrl;
        },
        hiresUrl: function () {
            return this.currentSlide.serverHiresImageUrl;
        },
        photographer: function () {
            return this.currentSlide.byLine;
        },
        virin: function () {
            return this.currentSlide.virin;
        },
        shareUrl: function () {
            const shareUrl = this.currentSlide.shareUrl;
            return shareUrl;
        },
        isVideo: function() {
            return this.currentSlide.isVideo;
        },
        fileSize: function() {
            return this.currentSlide.fileSize;
        },
        //
        // end of slide computers
        //////////////////////////

        infoStyles: function () {
            return {
                width: this.smallSize ? "100%" : this.withPx(this.infoWidth),
                // let children do this padding: this.withPx(this.contentPadding),
                marginLeft: this.smallSize ? 0 : this.withPx(this.contentPadding),
            }
        },
        mediaStyles: function () {
            return {
                width: this.smallSize ? "100%" : this.withPx(this.mediaWidth),
                height: this.smallSize ? "auto" : "100%",
            }
        },
    },
    methods: {
        withPx: function (arg) {
            return `${arg}px`
        },
        handleClose: function () {
            if (DEBUG) console.log("d2p172: handleClose", this.$props.onClose);
            if (this.$props.onClose) {
                this.$props.onClose();
            }
        },
        handleCurrentSizeSmall: function () {
            bodyScrollLock.enableBodyScroll(this);
            $("body > #Form").hide();
            const margin = this.smallSize ? this.smallPopupMargin : this.popupMargin;

            const ww = window.innerWidth;
            const wh = window.innerHeight;
            const extraPadding = 30 * 2;

            let mediaWidth = ww - extraPadding;
            let mediaHeight = mediaWidth / this.$props.mediaAspectRatio;

            this.mediaHeight = mediaHeight;
            this.mediaWidth = mediaWidth;
            this.contentTop = margin;
            this.contentBottom = margin;
            this.contentLeft = margin;
            this.contentRight = margin;
            return;
            if (Array.isArray(this.$refs.imgs)) {
                this.$nextTick ( () => {
                    for (let img of this.$refs.imgs) {
                        if (img.handleCurrentSize && typeof img.handleCurrentSize === 'function')
                            img.handleCurrentSize();
                    }
                });
            } else {
                this.$nextTick( () => {
                    if (this.$refs.imgs.handleCurrentSize && typeof this.$refs.imgs.handleCurrentSize === 'function')
                       this.$refs.imgs.handleCurrentSize()
                });
            }
            return;
        },
        handleCurrentSize: function () {
            // this.popupMargin is the minimum
            this.smallSize = window.matchMedia("screen and (max-width: 1200px)").matches;

            if (this.smallSize) {
                return this.handleCurrentSizeSmall();
            }

            $("body > #Form").show();
            bodyScrollLock.disableBodyScroll(this);

            const ww = window.innerWidth;
            const wh = window.innerHeight;
            const margin = this.smallSize ? this.smallPopupMargin : this.popupMargin;
            const extraPadding = this.contentPadding * 2 + margin * 2;

            // figure horizontal width first
            let mediaWidth = ww - extraPadding - this.infoWidth;
            let mediaHeight = mediaWidth / this.$props.mediaAspectRatio;

            // if the horizontal width forces the vertical width to be taller than the screen
            // then recalculate the width based on the correct height
            if (mediaHeight + extraPadding > wh) {
                mediaHeight = wh - extraPadding;
                mediaWidth = mediaHeight * this.$props.mediaAspectRatio;
            }

            const verticalMargin = (wh - (mediaHeight + this.contentPadding * 2)) / 2;
            const horizontalMargin = (ww - (mediaWidth + this.contentPadding * 2 + this.infoWidth)) / 2;

            this.mediaWidth = mediaWidth;
            this.mediaHeight = mediaHeight;
            this.contentTop = verticalMargin;
            this.contentBottom = verticalMargin;
            this.contentLeft = horizontalMargin;
            this.contentRight = horizontalMargin;
            if (Array.isArray(this.$refs.imgs)) {
                this.$nextTick ( () => {
                    for (let img of this.$refs.imgs) {
                        if (img.handleCurrentSize && typeof img.handleCurrentSize === 'function')
                            img.handleCurrentSize();
                    }
                });
            } else {

                this.$nextTick( () => {
                    if (this.$refs.imgs.handleCurrentSize && typeof this.$refs.imgs.handleCurrentSize === 'function')
                        this.$refs.imgs.handleCurrentSize()
                });
            }
            return;
        },
        onEscape: function () {
            this.handleClose();
        },
        onKeyup: function (e) {
            if (e.which == 27) {
                if (DEBUG) console.log('escape key pressed');
                this.onEscape();
            }
        },
        onSlideChange: function (currentSlide) {
            this.currentSlideIndex = currentSlide;

            // kludge b/c it's not keeping up with the current share URL
            this.$nextTick(() => {if (a2a) a2a.init_all(); });
        },
        methodContainerStyles: function () {
            const styles =  {
                top: this.withPx(this.contentTop),
                bottom: this.withPx(this.contentBottom),
                left: this.withPx(this.contentLeft),
                right: this.withPx(this.contentRight),
                padding: this.withPx(this.contentPadding),
            }
            if (DEBUG) console.log("d2p215: method container styles", styles);
            return styles;
        },
    },
    beforeDestroy: function () {
        // remove the resize listener when destroyed so that it stops firing
        window.removeEventListener('resize', this.handleCurrentSize);
        document.removeEventListener('keyup', this.onKeyup);

        // reset things that were set when mounted
        bodyScrollLock.enableBodyScroll(this);
        $('.page-wrap').removeClass('drop-transform');
        $("body > #Form").show();

        // Reset the body scroll position
        window.scroll({top: this.scrollPosition, behavior: 'instant'});
    },
    mounted: function () {
        // Initialize add to any
        if (a2a) a2a.init_all();

        // add the resize listener when mounted
        window.addEventListener('resize', this.handleCurrentSize);
        // Add event listener for escape key to close modal
        document.addEventListener("keyup", this.onKeyup);

        // Before doing things to the body, save the scroll position
        this.scrollPosition = window.scrollY;

        // hide the page form - this was done so that iphones can scroll the content
        if(window.matchMedia("(max-width:1200px)").matches) {
            $("body > #Form").hide();
            window.scroll({top: 0, behavior: 'instant'});
        } else {
            $('.page-wrap').addClass('drop-transform');
            bodyScrollLock.disableBodyScroll(this);
        }
    },
};
</script>
<style scoped src="./scss/dgov2Popup.scss"></style>